<div class="bg-container"></div>
<div class="container-fluid bg-img">
    <div class="form-card">
        <div class=" text-center">
            <img class="logo" src="../../../assets/Partanalytics_logo_white.svg" alt="PartAnalytics" />
            <div class="card p-3">
                <div>
                    <span class="error-text">
                        404
                    </span>
                    <h2>Oops! Page Not Found.</h2>
                </div>
                <h6>
                    Sorry the page you are looking for does not exist.
                </h6>
                <button type="button" class="btn btn-primary mt-2" [routerLink]="['/dashboard']">
                    Return Home
                </button>
            </div>

        </div>
    </div>
</div>